import axios from 'axios';
import * as Config from '../../config';

const state = {};

const actions = {

    whatsappTipoMensaje_get({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'whatsapp-tipo-mensaje/')
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    whatsappTipoMensaje_store({ commit }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'whatsapp-tipo-mensaje/store', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    whatsappTipoMensaje_update({ commit }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'whatsapp-tipo-mensaje/update', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    whatsappTipoMensaje_destroy({ commit }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'whatsapp-tipo-mensaje/destroy', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    // PLANTILLAS
    whatsappTipoMensaje_plantilla({ commit }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'whatsapp-tipo-mensaje/plantilla', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    whatsappTipoMensaje_plantilla_avisoUtilidad({ commit }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'whatsapp-tipo-mensaje/plantilla/aviso-utilidad', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    whatsappTipoMensaje_plantilla_recategorizacionPendiente({ commit }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'whatsapp-tipo-mensaje/plantilla/recategorizacion-pendiente', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    whatsappTipoMensaje_plantilla_vencimientoMonotributo({ commit }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'whatsapp-tipo-mensaje/plantilla/vencimiento-monotributo', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    whatsappTipoMensaje_plantilla_vencimientoPlanPagos({ commit }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'whatsapp-tipo-mensaje/plantilla/vencimiento-plan-pagos', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    whatsappTipoMensaje_plantilla_saldoFavorDetectado({ commit }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'whatsapp-tipo-mensaje/plantilla/saldo-favor-detectado', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

};

const mutations = {

};

export default {
    state,
    actions,
    mutations
};